// src/components/Projects.js
import React from 'react';

const projectItems = [
    {
        title: 'QUANTUM-ENHANCED PORTFOLIO OPTIMIZER (QEPO)',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/Quantum-Enhanced-Portfolio-Optimizer-QEPO-'
    },
    {
        title: 'Possibility Simulation for Territorial Disasters Using Augmented Reality',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/Possibility-Simulation-for-Territorial-Disasters-Using-Augmented-Reality'
    },
    {
        title: 'VentBuddyAI: Gen Z Therapist AI',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/VentbuddyAI'
    },
    {
        title: 'Cognitive Function Simulation',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/Cognitive-Function-Simulation'
    },
    {
        title: 'AI-powered Energy Management for Smart Homes',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/AI-powered-Energy-Management-for-Smart-Homes'
    },
    {
        title: 'Intelligent Chatbot for Customer Support',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/Intelligent-Chatbot-for-Customer-Support'
    },
    {
        title: 'EdNova - Online Education Platform',
        statusText: 'GitHub',
        link: 'https://github.com/ukexe/Ednova'
    }
];

const Projects = () => {
    return (
        <section className="projects">
            <div className="background-animation"></div>
            <h2 className="animated-title">Key Projects</h2>
            <div className="projects-quote">
                <p>Project highlights with direct repository links.</p>
            </div>

            <ul className="projects-list">
                {projectItems.map((project) => (
                    <li key={project.title} className="project-item">
                        <div className="project-line">
                            <span className="project-title">{project.title}</span>
                            <span className="separator"> — </span>
                            <a
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="project-link"
                            >
                                {project.statusText}
                            </a>
                        </div>
                    </li>
                ))}
            </ul>

            <style jsx>{`
                .projects {
                    padding: 2rem;
                    position: relative;
                    overflow: visible;
                }

                .background-animation {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(135deg, #1a1a2e, #0f0f1f);
                    z-index: -1;
                }

                .animated-title {
                    font-size: 2.5rem;
                    color: #00e6e6;
                    text-align: center;
                    margin-bottom: 1rem;
                    text-shadow: 0 0 10px rgba(0, 230, 230, 0.5);
                }

                .projects-quote {
                    text-align: center;
                    color: #b3b3b3;
                    margin-bottom: 2.5rem;
                    max-width: 760px;
                    margin-left: auto;
                    margin-right: auto;
                }

                .projects-list {
                    list-style: none;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 0.8rem;
                    max-width: 1100px;
                    margin: 0 auto;
                }

                .project-item {
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 12px;
                    padding: 1rem 1.25rem;
                    border: 1px solid rgba(0, 230, 230, 0.12);
                }

                .project-line {
                    display: block;
                    line-height: 1.6;
                }

                .project-title {
                    color: #00e6e6;
                    font-size: 1rem;
                    font-weight: 600;
                }

                .separator {
                    color: #a8a8a8;
                }

                .project-link {
                    color: #00e6e6;
                    text-decoration: underline;
                    font-size: 0.98rem;
                    font-weight: 600;
                }

                .project-link:hover {
                    color: #7ef7f7;
                }

                @media (max-width: 768px) {
                    .projects {
                        padding: 1rem;
                    }

                    .animated-title {
                        font-size: 2rem;
                    }

                    .project-item {
                        padding: 1rem;
                    }
                }
            `}</style>
        </section>
    );
};

export default Projects;
